import type { Deployment } from "@rebuild/shared";

const GITHUB_REPO = "rebuild-work/Rebuild_Monorepo";

function formatTimeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export function DeploymentInfo({ deployment, label }: { deployment: Deployment | null; label: string }) {
  if (!deployment) {
    return (
      <div className="flex-1 min-w-0">
        <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-1">{label}</p>
        <p className="text-sm text-gray-400 italic">No deployment</p>
      </div>
    );
  }

  const sha = deployment.commitSha?.slice(0, 7) ?? "—";
  const commitUrl = deployment.commitSha ? `https://github.com/${GITHUB_REPO}/commit/${deployment.commitSha}` : null;
  const prUrl = deployment.prId ? `https://github.com/${GITHUB_REPO}/pull/${deployment.prId}` : null;
  const desc = deployment.commitMessage ?? deployment.artifactRef ?? deployment.id;

  return (
    <div className="flex-1 min-w-0">
      <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-1">{label}</p>
      <div className="flex items-center gap-2">
        {commitUrl ? (
          <a href={commitUrl} target="_blank" rel="noopener noreferrer" className="text-sm font-mono text-gray-900 bg-gray-100 px-1.5 py-0.5 rounded hover:bg-gray-200 transition-colors">{sha}</a>
        ) : (
          <code className="text-sm font-mono text-gray-900 bg-gray-100 px-1.5 py-0.5 rounded">{sha}</code>
        )}
        {prUrl && (
          <a href={prUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-indigo-600 hover:text-indigo-500 font-medium transition-colors">PR #{deployment.prId}</a>
        )}
        <span className="text-xs text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded">{deployment.provider}</span>
      </div>
      <p className="text-sm text-gray-500 truncate mt-0.5" title={desc}>{desc}</p>
      <p className="text-xs text-gray-400 mt-0.5">
        {formatTimeAgo(deployment.createdAt)}
        {deployment.creator && ` by ${deployment.creator}`}
      </p>
    </div>
  );
}
